/**
 * @file Identity related mutations.
 */

import gql from 'graphql-tag';

import { IdentityDetails } from '../fragments/identity';

export const identityCreate = gql`
  mutation identityCreate($input: CreateIdentityInput!) {
    identityCreate(input: $input) {
      identity {
        ...IdentityDetails
      }
    }
  }
  ${IdentityDetails}
`;

export const identityUpdate = gql`
  mutation identityUpdate($input: UpdateIdentityInput!) {
    identityUpdate(input: $input) {
      identity {
        ...IdentityDetails
      }
    }
  }
  ${IdentityDetails}
`;

export const identityDelete = gql`
  mutation identityDelete($input: IdentityDeleteInput!) {
    identityDelete(input: $input) {
      deleted
    }
  }
`;

export const updateSelfie = gql`
  mutation updateSelfie($input: UpdateSelfieInput!) {
    updateSelfie(input: $input) {
      identity {
        ...IdentityDetails
      }
    }
  }
  ${IdentityDetails}
`;
